import { render, staticRenderFns } from "./form-check-img.vue?vue&type=template&id=07324298&scoped=true&"
import script from "./form-check-img.vue?vue&type=script&lang=ts&"
export * from "./form-check-img.vue?vue&type=script&lang=ts&"
import style0 from "./form-check-img.vue?vue&type=style&index=0&id=07324298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07324298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VInput,VRow})
